import { type FC, type ReactNode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import FooterRenderer from './FooterRenderer/FooterRenderer';

type ResponsiveFooterRenderArgs = {
    node: Element;
    Wrapper: FC<{ children: ReactNode }>;
};

export async function render({ node, Wrapper }: ResponsiveFooterRenderArgs): Promise<void> {
    hydrateRoot(
        node,
        <Wrapper>
            <FooterRenderer />
        </Wrapper>,
        { identifierPrefix: 'footer' }
    );
}
